import { useRef } from "react";

export function useDebounce(callback: () => void, timeoutMs: number): () => void {
  const timerRef = useRef<number | null>(null);

  return () => {
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
    }

    timerRef.current = window.setTimeout(() => {
      callback();
      timerRef.current = null;
    }, timeoutMs);
  };
}
